import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body p-xl-40" }
const _hoisted_2 = { class: "control-panel mb-30 p-4 bg_ash rounded-1 border" }
const _hoisted_3 = { class: "row align-items-center g-3" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "fs-16 mb-0 text-title" }
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "d-flex flex-wrap justify-content-lg-end align-items-center gap-4" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_10 = { class: "d-flex align-items-center gap-4 border-start ps-4" }
const _hoisted_11 = { class: "form-check form-switch custom-switch mb-0" }
const _hoisted_12 = { class: "form-check form-switch custom-switch mb-0" }
const _hoisted_13 = { class: "form-check form-switch custom-switch mb-0" }
const _hoisted_14 = { class: "barcode-wrap" }
const _hoisted_15 = {
  key: 0,
  class: "fs-12 text-title d-block mb-2"
}
const _hoisted_16 = { class: "code-container" }
const _hoisted_17 = { class: "mt-2" }
const _hoisted_18 = {
  key: 0,
  class: "fs-12 text-title d-block"
}
const _hoisted_19 = {
  key: 1,
  class: "fs-14 fw-bold text-black d-block mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarcodeGenerator = _resolveComponent("BarcodeGenerator")!
  const _component_QRCodeGenerator = _resolveComponent("QRCodeGenerator")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card border-0 shadow-none rounded-1 mb-50 barcode-wrapper barcode-print-root', { open: _ctx.toggleBarcode.open }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h6", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-store-2-line me-2" }, null, -1)),
              _createTextVNode("Warehouse: " + _toDisplayString(_ctx.selectedWarehouseName || 'Not Selected'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "fs-14 fw-medium text-black me-3" }, "Print Type:", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stateStore.printType) = $event)),
                    value: "barcode",
                    id: "printBarcode",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelRadio, _ctx.stateStore.printType]
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("label", {
                    class: "btn btn-outline-primary fs-13 px-3 py-2",
                    for: "printBarcode"
                  }, [
                    _createElementVNode("i", { class: "ri-barcode-line me-1" }),
                    _createTextVNode(" Barcode ")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.stateStore.printType) = $event)),
                    value: "qrcode",
                    id: "printQRcode",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelRadio, _ctx.stateStore.printType]
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("label", {
                    class: "btn btn-outline-primary fs-13 px-3 py-2",
                    for: "printQRcode"
                  }, [
                    _createElementVNode("i", { class: "ri-qr-code-line me-1" }),
                    _createTextVNode(" QR Code ")
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stateStore.showName) = $event)),
                    id: "showName",
                    role: "switch"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.stateStore.showName]
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("label", {
                    class: "form-check-label fs-14 fw-medium text-black",
                    for: "showName"
                  }, "Show Name", -1))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stateStore.showCode) = $event)),
                    id: "showCode",
                    role: "switch"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.stateStore.showCode]
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("label", {
                    class: "form-check-label fs-14 fw-medium text-black",
                    for: "showCode"
                  }, "Show Code", -1))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.stateStore.showPrice) = $event)),
                    id: "showPrice",
                    role: "switch"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.stateStore.showPrice]
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("label", {
                    class: "form-check-label fs-14 fw-medium text-black",
                    for: "showPrice"
                  }, "Show Price", -1))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProducts, (product) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: product.id
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.qty, (n) => {
              return (_openBlock(), _createElementBlock("div", {
                key: n,
                class: "barcode-item text-center rounded-1"
              }, [
                (_ctx.stateStore.showName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(product.name), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.stateStore.printType === 'barcode')
                    ? (_openBlock(), _createBlock(_component_BarcodeGenerator, {
                        key: 0,
                        value: product.code,
                        height: 50,
                        width: 1.5,
                        displayValue: false
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_QRCodeGenerator, {
                        key: 1,
                        value: product.code,
                        size: 80
                      }, null, 8, ["value"]))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.stateStore.showCode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(product.code), 1))
                    : _createCommentVNode("", true),
                  (_ctx.stateStore.showPrice)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "$" + _toDisplayString(product.price), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ], 64))
        }), 128))
      ])
    ])
  ], 2))
}